import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { SalaryRole } from '../../domain/salary/types';

interface Props {
    value: number;
    onChange: (roleId: number) => void;
    roles: SalaryRole[];
}

const RoleSelectField = ({ value, onChange, roles }: Props) => {
    const { t } = useTranslation();
    return (
        <TextField
            size="small"
            select
            label={t('salary.employees.role')}
            value={value || ''}
            onChange={e => onChange(Number(e.target.value))}
            sx={{ minWidth: 160 }}
        >
            {roles.map(role => (
                <MenuItem key={role.id} value={role.id}>
                    {role.name}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default RoleSelectField;
